import React from 'react';

import { IDetailsProps } from '../props';
import { InfoBox, InfoLabel, InfoData } from '../styles';
import Code from '../../../dtos/Code';

export interface SaasProps extends Code {
  fields: {
    displayName: string;
    value: string;
  }[];
}

const SaasData: React.FC<IDetailsProps<SaasProps>> = ({ data }) => {
  if (!data?.fields || data.fields.length === 0) {
    return null;
  }

  return (
    <>
      {data.fields.map(({ displayName, value }, idx) => (
        <InfoBox key={idx}>
          <InfoLabel>{displayName}</InfoLabel>
          <InfoData>{value}</InfoData>
        </InfoBox>
      ))}
    </>
  );
};

export default SaasData;
